import React from 'react';
import { tradeLinks, sellerLinks, companyLinks, sitemapLinks, connectLinks } from './Footer/links';
import { FormattedMessage } from 'react-intl';

const tradeLinksConfig = {
    title: <FormattedMessage id="footer.tradeLinks.title" defaultMessage="Trade" />,
    items: tradeLinks,
};

const sellerLinksConfig = {
    title: <FormattedMessage id="footer.sellerLinks.title" defaultMessage="Sellers" />,
    items: sellerLinks,
};

const companyLinksConfig = {
    title: <FormattedMessage id="footer.ourCompany.title" defaultMessage="Our Company" />,
    items: companyLinks,
};

const sitemapLinksConfig = {
    title: <FormattedMessage id="footer.categories.title" defaultMessage="Categories" />,
    items: sitemapLinks,
    enablerKey: 'isSiteMapsEnabled',
};

const connectLinksConfig = {
    title: <FormattedMessage id="footer.connect.title" defaultMessage="Connect With Us" />,
    items: connectLinks,
};

export const linkColumnConfig = [
    {
        ...tradeLinksConfig,
        additionalLink: sellerLinksConfig,
        columnWidth: 2,
    },
    {
        ...companyLinksConfig,
        columnWidth: 2,
    },
    {
        ...sitemapLinksConfig,
        columnWidth: 3,
    },
    {
        ...connectLinksConfig,
        sectionName: 'connect-with-us',
        columnWidth: 3,
    },
];

export const mobileLinkDrawerConfig = [
    tradeLinksConfig,
    sellerLinksConfig,
    companyLinksConfig,
    sitemapLinksConfig,
    connectLinksConfig,
];

export const filterLinks = (links, viewer) => {
    return links.filter(link => {
        if (
            (link.enablerKey && viewer[link.enablerKey] === false) ||
            (link.disablerKey && viewer[link.disablerKey] === true)
        ) {
            return null;
        }
        return link;
    });
};
